// ANGULAR COMPONENTS
import { NgRedux, DevToolsExtension } from "@angular-redux/store";
import { rootReducer } from "./ThemeOptions/store";
import { registerLocaleData, } from "@angular/common";
import localePt from "@angular/common/locales/pt";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { CUSTOM_ERRORS } from "./configs/custom-erros";
const DEFAULT_PERFECT_SCROLLBAR_CONFIG = {
    suppressScrollX: true,
};
const DEFAULT_DROPZONE_CONFIG = {
    // Change this to your upload POST address:
    url: "https://httpbin.org/post",
    maxFilesize: 50,
    acceptedFiles: "image/*",
};
const ɵ0 = adapterFactory, ɵ1 = DEFAULT_PERFECT_SCROLLBAR_CONFIG, ɵ2 = CUSTOM_ERRORS;
export class AppModule {
    constructor(ngRedux, devTool) {
        this.ngRedux = ngRedux;
        this.devTool = devTool;
        this.ngRedux.configureStore(rootReducer, {}, [], [this.devTool.isEnabled() ? this.devTool.enhancer() : (f) => f]);
        // ToastrModule.forRoot({ positionClass: 'toast-top-center', progressBar: true, progressAnimation: 'decreasing' }),
    }
}
registerLocaleData(localePt);
export { ɵ0, ɵ1, ɵ2 };
